import React,{Component} from "react";
import { connect } from "react-redux";
import { Alert, Modal, ModalHeader,ModalBody } from 'reactstrap';
import Form from "./Form";
import Actions from "../../../Actions";
import Tile from "../Layout/Tile";

class JobAdd extends Component{
    constructor(props){
        super(props);
        this.alertRef = false;
    }

    componentDidUpdate(){
        const {jobStore: { alert: { add }, jobSubmitted } } = this.props;
        if(add && !jobSubmitted && this.modalRef ) this.modalRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
    }

    render = () => {
        const { jobStore: { alert: { add } }, modalStore: { add: { modal }}, toggleModal } = this.props;
        const { addJob } = this.props;
        const data = { status: 1 };
        return (
            <div>
                <Modal size="lg" isOpen={modal} keyboard={false} toggle={() => toggleModal("jobs","add")}>
                    <ModalHeader toggle={() => toggleModal("jobs","add")}>Add Job</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                {add !== false &&
                                    <Alert color={add.type}>
                                        { add.message }
                                    </Alert>                                         
                                }
                                <Form data={data} persist={addJob} />
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    jobStore: state.jobStore,
    modalStore: state.modalStore.jobs,
});

const { jobs, modals } = Actions;

export default connect(mapStateToProps, { ...jobs, ...modals })(JobAdd);


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/Add.js